import { render, staticRenderFns } from "./BlockFreeText.vue?vue&type=template&id=a39558c0"
import script from "./BlockFreeText.vue?vue&type=script&lang=js"
export * from "./BlockFreeText.vue?vue&type=script&lang=js"
import style0 from "./BlockFreeText.vue?vue&type=style&index=0&id=a39558c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports